var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemplatesWhiteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.035,
    height: 12,
    viewBox: "0 0 12.035 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Templates_gray",
    transform: "translate(-10067 760)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160891",
    "data-name": "Group 160891",
    transform: "translate(10067 -760)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160890",
    "data-name": "Group 160890"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140092",
    "data-name": "Rectangle 140092",
    width: 12,
    height: 12,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160827",
    "data-name": "Group 160827",
    transform: "translate(2998.13 -333.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "M0,0H11.662V11.662H0Z",
    transform: "translate(7069.243 -426.526)",
    fill: "none",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "Templates_gray-2",
    "data-name": "Templates_gray",
    transform: "translate(10065.89 -761.325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    d: "M3,15H4.338a.944.944,0,0,1,.76.366l.371.5a.944.944,0,0,0,.76.366H7.992a.944.944,0,0,0,.76-.366l.371-.5A.944.944,0,0,1,9.883,15h1.338",
    transform: "translate(0 -6.085)",
    fill: "none",
    stroke: "#71839b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    d: "M3,11h8.221",
    transform: "translate(0 -4.105)",
    fill: "none",
    stroke: "#71839b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    d: "M3,7h8.221",
    transform: "translate(0 -2.052)",
    fill: "none",
    stroke: "#71839b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2326",
    "data-name": "Path 2326",
    d: "M3,4.948c0-.918,0-1.377.268-1.662S3.966,3,4.827,3H9.394c.861,0,1.292,0,1.559.285s.268.744.268,1.662h0V9.816c0,.918,0,1.377-.268,1.662s-.7.285-1.559.285H4.827c-.861,0-1.292,0-1.559-.285S3,10.735,3,9.816V4.948Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#71839b",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplatesWhiteIcon);
export default __webpack_public_path__ + "static/media/templates-white-icon.efc02a87d6963d710f1f41cbf49bbf9d.svg";
export { ForwardRef as ReactComponent };